import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cab711d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-container" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Informations supplémentaires", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "close" }, "×", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "certifications" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Certifications", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_12 = { class: "specificite" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Spécificités", -1))
const _hoisted_14 = { class: "conservation" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Type de conservation", -1))
const _hoisted_16 = { class: "volume" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Volume", -1))
const _hoisted_18 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "header", {}, () => [
                _hoisted_5,
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }, _hoisted_7)
              ], true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "body", {}, () => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entreprise_certifications, (certification) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "certification",
                          key: certification.id
                        }, _toDisplayString(certification.nom), 1))
                      }), 128))
                    ])
                  ]),
                  _hoisted_11,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entreprise_produits, (produit) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "produits",
                      key: produit.id
                    }, [
                      _createElementVNode("h2", null, _toDisplayString(produit.produit.nom), 1),
                      _createElementVNode("ul", _hoisted_12, [
                        _hoisted_13,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(produit.specificites, (specificite) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: specificite.id
                          }, _toDisplayString(specificite.nom), 1))
                        }), 128))
                      ]),
                      _createElementVNode("ul", _hoisted_14, [
                        _hoisted_15,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(produit.conservations, (conservation) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: conservation.id
                          }, _toDisplayString(conservation.nom), 1))
                        }), 128))
                      ]),
                      _createElementVNode("ul", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("li", null, _toDisplayString(produit.volume.nom), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ], true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
            ])
          ])
        ])
      ])
    ]),
    _: 3
  }))
}